import { Card, type CardProps } from "@blueprintjs/core";
import type { ReactNode } from "react";

type DashboardCardProps = CardProps & {
  title?: string;
  actions?: ReactNode;
};

// Shared base look for the location analytics dashboard panels — callers
// supply only their layout modifiers via `className`. `title`/`actions` add
// the small header row a few callers need without every caller hand-rolling
// its own `<h3>` + flex row on top.
export function DashboardCard({
  actions,
  children,
  className = "",
  title,
  ...props
}: DashboardCardProps) {
  return (
    <Card
      compact
      elevation={0}
      className={`rounded-xl border border-brand-line shadow-sm ${className}`}
      {...props}
    >
      {(title || actions) && (
        <div className="mb-2 flex items-center justify-between gap-2">
          {title && (
            <h3 className="m-0 text-sm font-semibold text-brand-ink">
              {title}
            </h3>
          )}
          {actions}
        </div>
      )}
      {children}
    </Card>
  );
}
